const apiConfig = {
  local: "http://localhost:9001/api/",
  uat: "https://api.uat.myaccount.nova-dev.ro/api/",
  dev: "https://api.dev.myaccount.nova-dev.ro/api/",
  prod: "https://api.nova-energy.ro/api/",
};

export const API_URL =
  apiConfig[process.env.REACT_APP_ENV_CODE] || apiConfig["local"];
